import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { useState } from 'react'

import LocationSearchContainer from '../location-search/LocationSearchContainer'
import { DialogSelectLocation } from '../register/DialogSelectLocation'
import PanelHeader from '../common/PanelHeader'
import ListLocations from './saved-locations/ListLocations'

const useStyles = makeStyles(theme => ({
  dialog: {
    '& .MuiDialog-paper': {
      overflowY: 'visible',
    },
  },
  dialogContent: {
    overflowY: 'visible',
  },
}))

const PanelLocation = ({
  deleteUserSavedLocationStart,
  isScriptLoadSucceed,
  isScriptLoaded,
  isUpdatingSavedLocation,
  location,
  savedLocations,
  updateAndSaveUserLocationStart,
  updateSavedLocationError,
  updateUserSavedLocationStart,
}) => {
  const classes = useStyles()

  const [showLocationModal, setShowLocationModal] = useState(false)
  return (
    <>
      <PanelHeader
        headerRight={
          <Button color="primary" onClick={() => setShowLocationModal(true)} size="small">
            Search new location
          </Button>
        }
        title="Locations"
      />
      <Dialog
        className={classes.dialog}
        fullWidth
        onClose={() => setShowLocationModal(false)}
        open={Boolean(showLocationModal)}
      >
        <DialogContent className={classes.dialogContent}>
          <LocationSearchContainer redirectOverride />
          <DialogSelectLocation
            isScriptLoaded={isScriptLoaded}
            isScriptLoadSucceed={isScriptLoadSucceed}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowLocationModal(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
      <ListLocations
        defaultLocation={location}
        deleteUserSavedLocationStart={deleteUserSavedLocationStart}
        isUpdatingSavedLocation={isUpdatingSavedLocation}
        savedLocations={savedLocations}
        updateAndSaveUserLocationStart={updateAndSaveUserLocationStart}
        updateSavedLocationError={updateSavedLocationError}
        updateUserSavedLocationStart={updateUserSavedLocationStart}
      />
    </>
  )
}

export default PanelLocation
